import type { BoardItemListItemResponse } from "@/client";

export const RENDERING_STATUS = "rendering";
export const RENDERING_POLL_INTERVAL_MS = 20_000;

export function hasRenderingClips(clips: BoardItemListItemResponse[]): boolean {
	return clips.some((clip) => clip.status === RENDERING_STATUS);
}

export function mergeClipsById(
	current: BoardItemListItemResponse[],
	fresh: BoardItemListItemResponse[],
): BoardItemListItemResponse[] {
	if (fresh.length === 0) {
		return current;
	}

	const freshById = new Map(
		fresh.flatMap((clip) => (clip.id ? [[clip.id, clip] as const] : [])),
	);

	return current.map((clip) => {
		if (!clip.id) {
			return clip;
		}
		return freshById.get(clip.id) ?? clip;
	});
}

export async function refreshLoadedBoardClips(
	lastLoadedPage: number,
	currentClips: BoardItemListItemResponse[],
	fetchPage: (page: number) => Promise<BoardItemListItemResponse[]>,
): Promise<BoardItemListItemResponse[]> {
	if (lastLoadedPage < 1) {
		return currentClips;
	}

	const refreshed = await Promise.all(
		Array.from({ length: lastLoadedPage }, (_, index) => fetchPage(index + 1)),
	);

	return mergeClipsById(currentClips, refreshed.flat());
}
